import { jsx as l } from "react/jsx-runtime";
import { Alert as i } from "./Alert.js";
const e = ({ errors: r }) => !r || r.length === 0 ? null : /* @__PURE__ */ l(i, { title: "Erros de validação", color: "danger", variant: "soft", fullWidth: !0, children: /* @__PURE__ */ l("ul", { children: r.map((t) => /* @__PURE__ */ l("li", { children: t })) }) });
export {
  e as V
};
